export default "__VITE_ASSET__D7WM0TCR__"